import { Module } from 'vuex';
import { IDeal } from '@/dealboard/types/deal';
import { RootState } from '@/store/store';
import { actions } from '@/dealboard/store/dealboard.actions';
import { mutations } from '@/dealboard/store/dealboard.mutations';

export interface IDealboardState {
  deals: IDeal[];
  dealBank: IDeal[];
  totalValue: number;
  isLoading: boolean;
  isLoaded: boolean;
  pagination: {
    currentPage: number;
    pageSize: number;
  };
}

export const namespace = 'dealboard';

export const state: IDealboardState = {
  deals: [],
  dealBank: [],
  totalValue: 0,
  isLoading: false,
  isLoaded: false,
  pagination: {
    currentPage: 0,
    pageSize: 20,
  },
};

export const dealboard: Module<IDealboardState, RootState> = {
  state,
  namespaced: true,
  actions,
  mutations,
};
